// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@eisinc/XDL/types";

export default {
    primary: {
        main: "#203F64",
        contrast: "#FFFFFF",
    },
    secondary: {
        main: "#666666",
        contrast: "#FFFFFF",
    },
    common: {
        background: "#FFFFFF",
        backgroundContrast: "#363636",
        accent: "#F8F9FA",
        accentContrast: "#363636",
        border: "#D7D7D7",
        disabled: "#F5F5F5",
        ui1: "#FFFFFF",
        ui2: "#F5F5F5",
        ui3: "#D7D7D7",
        ui4: "#999999",
        ui5: "#424242",
        ui6: "#333333",
        ui7: "#000000",
        ui8: "#3872B8",
        ui9: "#122236",
        ui10: "#F0760B",
        white: "#FFFFFF",
        black: "#000000",
        inverse: "#FFFFFF",
        gray: "#D7D7D7",
    },
    text: {
        main: "#333333",
        disabled: "#F5F5F5",
        accent: "#D7D7D7",
        link: "#203F64",
    },
    success: {
        main: "#00A65A",
        light: "#D9F2E7",
        contrast: "#FFFFFF",
    },
    danger: {
        main: "#F9151E",
        light: "#FBDBE5",
        contrast: "#FFFFFF",
    },
    warning: {
        main: "#F9AA19",
        light: "#FDF9DE",
        contrast: "#FFFFFF",
    },
    partial: {
        main: "#845FA8",
        contrast: "#FFFFFF",
    },
    info: {
        main: "#008CDD",
        light: "#DDEEF8",
        contrast: "#FFFFFF",
    },
    transparent: {
        main: "transparent",
        contrast: "#424242",
    },
} as xBaseTheme["colors"];
